// Sources by link (URL inputs). Both screens hang off a channel card, so they
// have no menu entry: "Добавить источник по ссылке" and "Настройки источника
// по ссылке" of an existing input (engineer, updateChannel), and "Сменить
// ссылку" of an existing slot (operator, setInputURL).
import { operationMinRole } from '@/api/access'
import { defineFeatureRoutes } from '@/app/router/registry'
import { messages } from './i18n'

export const SOURCE_URL_ADD_ROUTE = 'source-url-add'
export const SOURCE_URL_EDIT_ROUTE = 'source-url-edit'
export const SOURCE_URL_SETTINGS_ROUTE = 'source-url-settings'

export default defineFeatureRoutes([
  {
    path: '/channels/:id/sources/url',
    name: SOURCE_URL_ADD_ROUTE,
    component: () => import('./AddUrlSourceView.vue'),
    props: true,
    meta: { title: messages.lazy('titleAdd'), minRole: operationMinRole('updateChannel') ?? undefined },
  },
  {
    path: '/channels/:id/inputs/:inputId/url/settings',
    name: SOURCE_URL_SETTINGS_ROUTE,
    component: () => import('./AddUrlSourceView.vue'),
    props: true,
    meta: { title: messages.lazy('titleSettings'), minRole: operationMinRole('updateChannel') ?? undefined },
  },
  {
    path: '/channels/:id/inputs/:inputId/url',
    name: SOURCE_URL_EDIT_ROUTE,
    component: () => import('./EditUrlSlotView.vue'),
    props: true,
    meta: { title: messages.lazy('titleChangeUrl'), minRole: operationMinRole('setInputURL') ?? undefined },
  },
])
